import { app, type AppState } from "../state/app-state.js";

const template = document.createElement("template");
template.innerHTML = `
  <style>
    :host {
      display: grid;
      place-items: center;
      min-block-size: 100dvh;
    }

    h1 {
      margin: 0;
      font-size: 5.5rem;
      font-weight: 600;
      letter-spacing: -0.02em;
      font-family: "Playfair Display", serif;
      font-optical-sizing: auto;
      font-weight: 800;
      font-style: normal;
      line-height: 0.75;
    }
  </style>

  <section class="card">
    <h1>BAM<br/>BAM</h1>
  </section>
`;

export class AppRoot extends HTMLElement {
  #unsubscribe: (() => void) | undefined;

  constructor() {
    super();
    const root = this.attachShadow({ mode: "open" });
    root.append(template.content.cloneNode(true));
  }

  connectedCallback(): void {
    this.#render(app.state);
    this.#unsubscribe = app.subscribe((state) => this.#render(state));
  }

  disconnectedCallback(): void {
    this.#unsubscribe?.();
    this.#unsubscribe = undefined;
  }

  #render(state: Readonly<AppState>): void {
  }
}

customElements.define("app-root", AppRoot);

declare global {
  interface HTMLElementTagNameMap {
    "app-root": AppRoot;
  }
}
